import { useContext, useEffect } from 'react';
import { intersectionBy, unionBy, reject, find } from 'lodash';
import { GridContext } from '../';

export const usePreservedSelection = () => {
  const { state, dispatch } = useContext(GridContext);
  const { items, selectedItems, selectedItemsInAllPages } = state;

  useEffect(() => {
    const newSelectedItems = intersectionBy(items, selectedItemsInAllPages, 'key');
    dispatch({ type: 'SET_SELECTION', payload: newSelectedItems });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    const unselected = reject(items, item => find(selectedItems, item));
    let newSelectedItems = reject(selectedItemsInAllPages, item => find(unselected, item)); // remove unselected items
    newSelectedItems = unionBy(selectedItems, newSelectedItems, 'key'); // add new selected items
    dispatch({ type: 'SET_SELECTED_ITEMS_IN_ALL_PAGES', payload: newSelectedItems });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);
};
